// extracted by mini-css-extract-plugin
export default {"container":"BonusMotivator_container__gU-Q6","text":"BonusMotivator_text__9r2DX"};